var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHideComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.71,5.29l.29,.71V15l-.29,.71-2,2-.71,.29h-6.43l-2.71,4.51h-1.71l-1.7-2.84,1.46-1.46,1.1,1.84,2.14-3.57,.86-.49h6.59l1.41-1.41V6.41l-.15-.15,1.41-1.41,.44,.44ZM3.63,20.66l-1.41-1.41,1.4-1.4-.32-.13-2-2-.29-.71V6l.29-.71L3.29,3.29l.71-.29h14.46l2.27-2.27,1.41,1.41L3.63,20.66Zm1.83-4.66L16.46,5H4.41l-1.41,1.41V14.59l1.41,1.41h1.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHideComments);
export default __webpack_public_path__ + "static/1765983986/media/icon-hide-comments.d72ab4e003f3d3958a6ccf3022a7fe05.svg";
export { ForwardRef as ReactComponent };